import SystemConstants from '@app/constants/SystemConstants'

// ローカルストレージのdevice_idを削除する
export default async function ({
  app,
  store,
  route,
  redirect,
}: {
  app: any
  store: any
  route: any
  redirect: any
}) {
  localStorage.removeItem(SystemConstants.deviceIdKey)
}
